<template>
    <div class="code-main">
      <div class="content-box">
        <div class="mar">
          <div>
            <div class="img-box">
              <img :src="'data:image/png;base64,'+userInfo.image" alt="">
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">发证日期:</span>
              <span>{{userInfo.passTime}}</span>
            </div>
            <div>
              <span>DATE OF ISSUE:{{userInfo.ppassTime}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">起止级:</span>
              <span>{{userInfo.startAndEnd}}</span>
            </div>
            <div>
              <span>STARTING AND <br>ENDING GRADES:THE GRADE OF {{userInfo.startAndEnd}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">考级专业:</span>
              <span>{{userInfo.major}}</span>
            </div>
            <div>
              <span>SPECIALITY:{{userInfo.pmajor}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">证书编号:</span>
              <span>{{userInfo.no}}</span>
            </div>
            <div>
              <span>NO:{{userInfo.pno}}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="item">
            <div>
              <span class="title">姓名:</span>
              <span>{{userInfo.name}}</span>
            </div>
            <div>
              <span>NAME:{{userInfo.pname}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">性别:</span>
              <span>{{userInfo.sex}}</span>
            </div>
            <div>
              <span>GENDER:{{userInfo.psex}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">国籍: </span>
              <span>{{userInfo.country}}</span>
            </div>
            <div>
              <span>NATIONALITY:{{userInfo.pcountry}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">出生日期:</span>
              <span>{{userInfo.birth}}</span>
            </div>
            <div>
              <span>DATE OF BIRTH:{{userInfo.pbirth}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">成绩:</span>
              <span>{{userInfo.score}}</span>
            </div>
            <div>
              <span>SCORE:{{userInfo.pscore}}</span>
            </div>
          </div>
          <div class="item">
            <div>
              <span class="title">等级:</span>
              <span>{{userInfo.level}}</span>
            </div>
            <div>
              <span>GRADE:{{userInfo.plevel}}</span>
            </div>
          </div>
          <!-- <div class="item">
            <div>
              <span class="title">浙江音乐学院</span>
            </div>
            <div>
              <span>ZHEJIANG CONSERVATORY OF MUSIC</span>
            </div>
          </div> -->
        </div>
      </div>
      <div class="center">
         <div class="left">
           <div class="title">浙江音乐学院</div>
           <div class="title">院长:</div>
         </div>
         <div class="right">浙江音乐学院</div>
      </div>
      <div class="code-img-box">
        <div>
          <div style="width: 80px;height: 80px;"></div>
        </div>
        <div>浙江音乐学院考级委员会监制</div>
        <div></div>
      </div>
    </div>
</template>

<script>
export default {
  beforeCreate() {
    if (!this.$route.query.registerId) {
      this.$message.warning({ message: "缺少必要参数，无法展示!" ,duration:1000});
      return;
    }
  },
  created() {
    this.$axios
        .get(
            `score/qrcodeLook/${this.$route.query.registerId}`
        )
        .then((res) => {
          this.userInfo = res.data.data;
        });
  },
  data() {
    return {
      userInfo: {
        passTime:''
      },
    };
  },
};
</script>
<style lang="scss" scoped>
$padding: 14%;
.code-main{
  height: 920px;
  width: 680px;
  //height: 100%;
  background-image: url("./../../../assets/img/code-back.jpg");
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
}
.mar{
  margin-right: 20px;
}
.center{
  display: flex;
  padding-left: 20%;
  margin: 4% 8% -4% 0%;
  font-size: 13px;
  font-weight: bold;
  .left{
     margin-right: 20px;
  }
  .right{
      margin: 1% 0 0 40% ;
  }
}
.img-box{
  width: 100px;
  height: 130px;
  margin: 0 0;
  img{
    width: 100%;
    height: 100%;
  }
}
.content-box{
  display: flex;
  padding-left: 20%;
  padding-bottom: 4%;

  flex: 1;
  >div{
    display: flex;
    justify-content: flex-end;
    flex-direction: column;

    .item{
      font-size: 13px;
      margin-top: 11%;
      .title{
        font-weight: bold;
      }
     >div:nth-child(2){
        font-size: 12.5px;
      }
    }
  }
  .right{
    .item{
      margin-top: 22%;
    }
  }
}
.code-img-box{
  display: flex;
  margin: 4% 8% 10% 8%;
  >div:nth-child(1),>div:nth-child(3){
    width: 80px;
  }
  >div:nth-child(2){
    flex: 1;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bolder;
  }
}
//.QRCodeBox {
//  width: 100vw;
//  height: 100vh;
//  overflow: auto;
//  position: relative;
//  .QRCodeFrom {
//    width: 660px;
//    height: 100vh;
//    min-height: 870px;
//    left: 0%;
//    background-image: url("./../../../assets/img/pdfBg.png");
//    background-size: 100% 100%;
//    position: absolute;
//    .titleBox1 {
//      margin-top: 18%;
//      padding: 0px $paddWidth1;
//      span {
//        font-size: 1.8rem;
//        font-weight: bold;
//      }
//    }
//    .titleBox2 {
//      padding: 0px $paddWidth1;
//      margin-top: 1%;
//      span {
//        font-size: 1rem;
//      }
//    }
//    .titleBox3 {
//      padding: 0px $paddWidth1;
//      margin-top: 1%;
//      span {
//        font-size: 1.8rem;
//        font-weight: bold;
//      }
//    }
//    .titleBox4 {
//      padding: 0px $paddWidth1;
//      margin-top: 1%;
//      span {
//        font-size: 1rem;
//      }
//    }
//    .leftBox {
//      width: 38%;
//      padding-left: 15%;
//      margin-top: 30px;
//      img{
//        width: 90px;
//        max-height: 150px;
//      }
//      .pBox {
//        margin-top: 50px;
//        p {
//          font-weight: bold;
//          line-height: 2.6;
//        }
//      }
//    }
//    .rightBox {
//      margin-top: 20px;
//      flex: 1;
//      padding-right: 10%;
//      p {
//        font-weight: bold;
//        line-height: 2.6;
//      }
//    }
//    .footTitle {
//      position: absolute;
//      bottom: 5%;
//      width: 100%;
//      p {
//        text-align: center;
//        line-height: 3;
//        font-size: 1.3rem;
//        font-weight: bold;
//      }
//    }
//  }
//}
</style>
